import { ClipboardIcon, EnvelopeIcon } from "@heroicons/react/20/solid";
import SlackIcon from "../../../../../assets/images/slack.svg?react";
import { cn } from "../../../../../lib/utils";

type Props = {
  selectedFilter: string;
  setSelectedFilter: (value: string) => void;
  selectedState: string;
  setSelectedState: (value: string) => void;
  title?: string;
};

type FilterOption = {
  value: string;
  label: string;
  icon?: React.ComponentType<any>;
};

const filterOptions: FilterOption[] = [
  { value: "all", label: "All" },
  { value: "send_to_slack", label: "Slack", icon: SlackIcon },
  { value: "send_to_inbox", label: "Inbox Only", icon: ClipboardIcon },
  { value: "send_to_email", label: "Email", icon: EnvelopeIcon },
];

const stateOptions: Array<{ value: string; label: string }> = [
  { value: "all", label: "All" },
  { value: "active", label: "On" },
  { value: "paused", label: "Off" },
];

const SignalControls = ({
  selectedFilter,
  setSelectedFilter,
  selectedState,
  setSelectedState,
  title = "Signals",
}: Props) => (
  <div className="flex flex-wrap items-center justify-between gap-3 border-b border-border px-6 py-4">
    <h2 className="text-base font-semibold text-foreground">{title}</h2>

    <div className="flex flex-wrap items-center gap-2">
      <div className="inline-flex items-center rounded-lg border border-border bg-muted p-0.5">
        {filterOptions.map((option) => {
          const Icon = option.icon;
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => setSelectedFilter(option.value)}
              className={cn(
                "inline-flex items-center gap-1.5 rounded-[5px] px-3 py-1 text-xs font-medium transition-colors",
                selectedFilter === option.value
                  ? "bg-card text-foreground shadow-sm"
                  : "text-muted-foreground hover:text-foreground",
              )}
            >
              {Icon ? <Icon className="h-3.5 w-3.5" /> : null}
              {option.label}
            </button>
          );
        })}
      </div>

      <div className="inline-flex items-center rounded-lg border border-border bg-muted p-0.5">
        {stateOptions.map((option) => (
          <button
            key={option.value}
            type="button"
            onClick={() => setSelectedState(option.value)}
            className={cn(
              "rounded-[5px] px-3 py-1 text-xs font-medium transition-colors",
              selectedState === option.value
                ? "bg-card text-foreground shadow-sm"
                : "text-muted-foreground hover:text-foreground",
            )}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  </div>
);

export default SignalControls;
